exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-7660586e]{padding-top:20px}", ""]);

// exports
